{
  "cookies-dialog": {
    "buttons": {
      "accept-all": "Accepter tous les cookies",
      "save": "Sauvegarder les paramètres",
      "setting": "Paramétrage des cookies"
    },
    "text": {
      "title": "Vie privée et cookies",
      "content-1": "Nous utilisons des outils d'analyse (par exemple des cookies ou des empreintes digitales) pour mesurer la fréquence de visite de notre site et la manière dont il est utilisé. Nous utilisons également du contenu technique de tiers pour simplifier le contrôle des balises (tag manager).",
      "content-2": "Dans ce contexte, nous faisons également appel à des prestataires de services dans des pays tiers en dehors de l'UE qui ne disposent pas d'un niveau adéquat de protection des données, ce qui entraîne les risques suivants : Accès des autorités sans information, absence de droits des personnes concernées, absence de recours juridique, perte de contrôle.",
      "content-3": "Vous trouverez de plus amples informations sur l'utilisation de vos données dans notre politique de confidentialité. En paramétrant le site, vous acceptez les processus décrits ci-dessus.",
      "essential-cookies": "Essentiel",
      "essential-cookies-description": "Les cookies essentiels permettent des fonctions de base et sont nécessaires au bon fonctionnement du site web.",
      "statistics-cookies": "Analyses et statistiques",
      "statistics-cookies-description": "Les cookies analytiques et statistiques collectent des informations de manière anonyme. Ces informations nous aident à comprendre comment nos visiteurs utilisent notre site web."
    }
  }
}
